import {IPaymentLinkV2ValidProps} from '@/app/main/paymentLink/v2/pages/paymentLinkV2/models/interfaces/paymentLinkV2.interfaces';

import {ICampaignConfiguration, ISavingsGoalConfiguration} from './entities';
import {
  ICampaignConfigurationResponse,
  IGetPaymentLinkV2Response,
  ISavingsGoalCustomizationResponse,
} from './models';

function mapCampaignConfiguration(
  resp?: ICampaignConfigurationResponse,
): ICampaignConfiguration | undefined {
  if (!resp) return undefined;
  return {
    title: resp.title,
    description: resp.description,
    imageUrl: resp.image_url,
    organizerName: resp.organizer_name,
    payerLimit: resp.payer_limit,
    collectionDeadline: resp.collection_deadline,
    type: resp.type,
  };
}

function mapSavingsGoalConfiguration(
  resp?: ISavingsGoalCustomizationResponse,
): ISavingsGoalConfiguration | undefined {
  if (!resp) return undefined;
  return {
    name: resp.name,
    icon: resp.icon,
    target: resp.target,
    motivation: resp.motivation,
  };
}

export function mapPaymentLinkToValidProps(
  id: string,
  resp: IGetPaymentLinkV2Response,
): IPaymentLinkV2ValidProps {
  return {
    paymentLinkId: id,
    receiverUserId: resp?.receiver_user_id,
    name: resp?.receiver_name,
    gif: resp?.gif,
    note: resp?.description,
    amount: resp?.amount,
    single_payment: resp?.single_payment,
    link_consumed: resp?.consumed,
    type: resp?.type,
    destinationAccountType: resp?.destination_account_type,
    campaignConfiguration: mapCampaignConfiguration(
      resp?.campaign_configuration,
    ),
    savingsGoalConfiguration: mapSavingsGoalConfiguration(resp?.customizations),
  };
}
